'use client';

import { type ReactNode } from "react";
import { FlagProvider } from "@unleash/nextjs";

import bootstrap from "@/services/unleash/bootstrap";

interface UnleashProviderInterface {
    children: ReactNode;
}

export default function UnleashProvider({
    children,
}: UnleashProviderInterface) {
    return (
        <FlagProvider config={
            {
                bootstrap: bootstrap
            }
        }>
            {children}
        </FlagProvider>
    );
}
